import { render, staticRenderFns } from "./positionManagement.vue?vue&type=template&id=f708cc18&scoped=true"
import script from "./positionManagement.vue?vue&type=script&lang=js"
export * from "./positionManagement.vue?vue&type=script&lang=js"
import style0 from "./positionManagement.vue?vue&type=style&index=0&id=f708cc18&prod&scoped=true&lang=css"
import style1 from "./positionManagement.vue?vue&type=style&index=1&id=f708cc18&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f708cc18",
  null
  
)

export default component.exports